export default __webpack_public_path__ + "static/media/jtt5.56a3a387.png";